module.exports = __webpack_public_path__ + "school/img/chuanNationCultureBg.c60942bc.jpg";